import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { siteInfo } from '../mock';
import logo from "../assets/Ayush-SPA-Photoroom.png";

const Footer = ({ setActiveSection }) => {
  return (
    <footer 
      className="text-white bg-cover bg-center bg-no-repeat bg-fixed"
      style={{ backgroundImage: "url('/gallary/g7.jpg')" }}
    >
      <div className="bg-black/70">
        <div className="container mx-auto px-4 py-16">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

            {/* About */}
            <div>
              <img
                src={logo}
                alt="Aayush Spa Logo"
                className="h-24 w-24 object-contain drop-shadow-lg"
              />
              <p className="text-gray-300 leading-relaxed mb-4">
                {siteInfo.name}, Your sanctuary of tranquility offering premium spa therapies and holistic wellness treatments.
              </p>

              <div className="flex gap-4">
                <a className="w-10 h-10 bg-amber-900 rounded-full flex items-center justify-center hover:bg-amber-700 transition-colors">
                  <Facebook size={20} />
                </a>
                <a className="w-10 h-10 bg-amber-900 rounded-full flex items-center justify-center hover:bg-amber-700 transition-colors">
                  <Instagram size={20} />
                </a>
                <a className="w-10 h-10 bg-amber-900 rounded-full flex items-center justify-center hover:bg-amber-700 transition-colors">
                  <Twitter size={20} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-semibold mb-4 text-amber-400">Quick Links</h4>
              <ul className="space-y-2">
                <li><button onClick={() => setActiveSection("home")} className="text-gray-300 hover:text-amber-400">Home</button></li>
                <li><button onClick={() => setActiveSection("about")} className="text-gray-300 hover:text-amber-400">About Us</button></li>
                <li><button onClick={() => setActiveSection("services")} className="text-gray-300 hover:text-amber-400">Services</button></li>
                <li><button onClick={() => setActiveSection("gallery")} className="text-gray-300 hover:text-amber-400">Gallery</button></li>
                <li><button onClick={() => setActiveSection("booking")} className="text-gray-300 hover:text-amber-400">Book Now</button></li>
              </ul>
            </div>

            {/* ⭐ Popular Services – CLICKABLE ⭐ */}
            <div>
              <h4 className="text-xl font-semibold mb-4 text-amber-400">Popular Services</h4>
              <ul className="space-y-2 text-gray-300">

                <li className="cursor-pointer hover:text-amber-400"
                    onClick={() => setActiveSection("thai")}>
                  - Thai Dry Massage
                </li>

                <li className="cursor-pointer hover:text-amber-400"
                    onClick={() => setActiveSection("aroma")}>
                  - Aroma Massage
                </li>

                <li className="cursor-pointer hover:text-amber-400"
                    onClick={() => setActiveSection("swedish")}>
                  - Swedish Massage
                </li>

                <li className="cursor-pointer hover:text-amber-400"
                    onClick={() => setActiveSection("balinese")}>
                  - Balinese Massage
                </li>

                <li className="cursor-pointer hover:text-amber-400"
                    onClick={() => setActiveSection("deep")}>
                  - Deep Tissue Massage
                </li>

                {/* ❌ Kansa Wand Removed */}

                <li className="cursor-pointer hover:text-amber-400"
                    onClick={() => setActiveSection("scrub")}>
                  - Body Scrub
                </li>

                {/* ❌ Body Polish Removed */}

              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-xl font-semibold mb-4 text-amber-400">Contact Us</h4>
              <ul className="space-y-4">

                <li className="flex items-start gap-3">
                  <MapPin size={20} className="text-amber-400 flex-shrink-0 mt-1" />
                  <span className="text-gray-300">
                    Shop No. 03, SLV Complex, 4th Floor,<br/>
                    Navodaya Nagar Bus Stand,<br/>
                    Kottanpur Dinne Main Road,<br/>
                    JP Nagar 7th Phase,<br/>
                    Bengaluru – 560078, Karnataka
                  </span>
                </li>

                <li className="flex items-center gap-3">
                  <Phone size={20} className="text-amber-400 flex-shrink-0" />
                  <a href={`tel:${siteInfo.phone}`} className="text-gray-300 hover:text-amber-400">
                    {siteInfo.phone}
                  </a>
                </li>

                <li className="flex items-center gap-3">
                  <Mail size={20} className="text-amber-400 flex-shrink-0" />
                  <a href={`mailto:${siteInfo.email}`} className="text-gray-300 hover:text-amber-400">
                    {siteInfo.email}
                  </a>
                </li>

              </ul>
            </div>

          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-black/80">
        <div className="container mx-auto px-4 py-6">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
